// @flow

export const apiVersion = '3ce7e6262acaf8cc6105fdf069044fbd2cc7c232';

export {
  default as queryMap,
} from 'queries/3ce7e6262acaf8cc6105fdf069044fbd2cc7c232.json';



// WEBPACK FOOTER //
// ./shared/api.js